import { render, staticRenderFns } from "./Sacola.vue?vue&type=template&id=557191dc&"
import script from "./Sacola.vue?vue&type=script&lang=js&"
export * from "./Sacola.vue?vue&type=script&lang=js&"
import style0 from "./Sacola.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports